var angularModule = angular.module('t2g.common.services.3rdParty', []);

module.exports = angularModule;

angularModule.factory('moment', function() {
  return window.moment;
});

angularModule.factory('_', function() {
  return window._;
});



// WEBPACK FOOTER //
// ./src/app/common/services/3rd-party.js